module.exports = __webpack_public_path__ + "img/menu.10066591.png";